<template>
  <div id="modal" class="modal product_search_modal" v-show="modalShown">
    <div id="product_search_main" v-bind:class="!isHaseko ? {'modal-main' : true, wrapper : true, search_height : true} : {'modal-main' : true, wrapper : true }">
      <div class="cross_btn2" @click="cancel()">
        <span class="css-cancel"></span>
      </div>
      <div class="modal_content_main">
        <div class="title">絞り込み検索</div>
        <section class="select_category"> <!-- 商品カテゴリ -->
          <h3>商品カテゴリ</h3>
          <div>
            <div v-for="(category, index) in categoryList" :key="'cate_' + index">
              <div v-bind:class="{cetegory_item: true, active: isSelCategory(category.id)}" @click="selectCategory(category)">
                <div>
                  <img :src="categoryImgBlack(category.img)" v-if="!isSelCategory(category.id)">
                  <img :src="categoryImgWhite(category.img)" v-else>
                </div>
                <div>{{categoryName(category.name)}}</div>
              </div>
            </div>
          </div>
        </section>
        <section> <!-- 対応サイズ -->
          <h3>希望サイズ</h3>
          <div class="search_outline">ご指定いただいた寸法でカスタマイズ可能な商品を表示いたします。</div>
          <div class="storage_size_area">
            <div class="storage_size">
              <div>幅</div>
              <input type="text" v-model.number="paramForm.minWidth" @keypress="validateNumber" @input="paramForm.minWidth=inputRestNumber($event)" @blur="onBlurStorageItemMinW" @focus="selectedAll">
              <div>mm</div>
            </div>
            <div class="storage_size">
              <div>高さ</div>
              <input type="text" v-model.number="paramForm.minHeight" @keypress="validateNumber" @input="paramForm.minHeight=inputRestNumber($event)" @blur="onBlurStorageItemMinH" @focus="selectedAll">
              <div>mm</div>
            </div>
            <div class="storage_size">
              <div>奥行き</div>
              <input type="text" v-model.number="paramForm.minDepth" @keypress="validateNumber" @input="paramForm.minDepth=inputRestNumber($event)" @blur="onBlurStorageItemMinD" @focus="selectedAll">
              <div>mm</div>
            </div>
          </div>
        </section>
        <section class="product_search_maker" v-if="!isHaseko"> <!-- メーカー -->
          <h3>メーカー</h3>
          <div class="search_outline">指定メーカーの商品を表示いたします。末尾に各社の所在エリアを記載しています。</div>
          <div class="search_maker_area">
            <div class="content_line">
              <input type="checkbox" :id="'maker_axis'" v-model="makerAxis" @change="selectMaker(10000)"/>
              <label :for="'maker_axis'">アクシス株式会社(近畿)</label>
            </div>
            <div class="content_line">
              <input type="checkbox" :id="'maker_tecma'" v-model="makerTecma" @change="selectMaker(10001)"/>
              <label :for="'maker_tecma'">株式会社テクマ(近畿)</label>
            </div>
            <div class="content_line">
              <input type="checkbox" :id="'maker_fm'" v-model="makerFm" @change="selectMaker(27)"/>
              <label :for="'maker_fm'">ファニチャーメーカー株式会社(関東)</label>
            </div>
            <div class="content_line">
              <input type="checkbox" :id="'maker_miura'" v-model="makerMiura" @change="selectMaker(1001)"/>
              <label :for="'maker_miura'">株式会社みうら(中国)</label>
            </div>
            <div class="content_line">
              <input type="checkbox" :id="'maker_domans'" v-model="makerDomans" @change="selectMaker(300)"/>
              <label :for="'maker_domans'">ドゥーマンズ株式会社(関東)</label>
            </div>
          </div>
        </section>
        <section class="product_search_maker" v-else> <!-- メーカー -->
          <h3>メーカー</h3>
          <div class="search_outline">指定メーカーの商品を表示いたします。末尾に各社の所在エリアを記載しています。</div>
          <div class="search_maker_area">
            <div class="content_line">
              <input type="checkbox" :id="'maker_fm'" v-model="makerFm" @change="selectMaker(27)"/>
              <label :for="'maker_fm'">ファニチャーメーカー株式会社(関東)</label>
            </div>
            <div class="content_line">
              <input type="checkbox" :id="'maker_domans'" v-model="makerDomans" @change="selectMaker(300)"/>
              <label :for="'maker_domans'">ドゥーマンズ株式会社(関東)</label>
            </div>
          </div>
        </section>
      </div>
      <section class="product_search_action"> <!-- 操作 -->
        <div>{{productCnt}}件の商品があります。</div>
        <div class="main_btn act_sub_btn icon_btn" @click="reset()" v-on:mouseover="isOnReset(true)" v-on:mouseleave="isOnReset(false)">
          <div>条件をリセット</div>
        </div>
        <div class="main_btn sel_main_btn icon_btn" @click="search()" v-on:mouseover="isOnSearch(true)" v-on:mouseleave="isOnSearch(false)">
          <!-- <img :src="imgSearch" class="icon"> -->
          <div>検索</div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as App from '../../../../../utils/App'
import * as Api from '../../../../../utils/Api'
import {DC_URL, DC_STORAGE_KEY, DC_PRPIC_ON} from '../../../../../constants/App'
import * as FormUtil from '../../../../../utils/FormUtil'
import * as Check from '../../../../../utils/Check'

export default {
  name: 'estimateModal',
  components: {
  },
  props: {
    /** OK押下時コールバック */
    onOk: {
      type: Function,
      default: function () {}
    },
    onCancel: {
      type: Function,
      default: function () {}
    },
    /** コールバックに渡す引数 */
    callbackParams: {
      type: Object,
      default: function () { return {} }
    },
    showSuccess: {
      type: Function,
      default: function () {}
    },
    isHaseko: {
      type: Boolean,
      default: false
    },
    categoryList: Array
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      newCnt: 0,
      productCnt: 0,
      paramForm: {
        minWidth: undefined,
        maxWidth: undefined,
        minHeight: undefined,
        maxHeight: undefined,
        minDepth: undefined,
        maxDepth: undefined
      },
      selCategoryList: [],
      makerIdList: [],
      makerFm: false,
      makerMiura: false,
      makerAxis: false,
      makerTecma: false,
      makerDomans: false,
      errors: {}
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
    showModal: function () {
      this.modalShown = true
      this.searchProductCnt()
    },
    reset: function () {
      this.errors = {}
      this.newCnt = 0
      this.paramForm = {
        minWidth: undefined,
        maxWidth: undefined,
        minHeight: undefined,
        maxHeight: undefined,
        minDepth: undefined,
        maxDepth: undefined
      }
      this.selCategoryList = []
      this.makerIdList = []
      this.makerFm = false
      this.makerMiura = false
      this.searchProductCnt()
    },
    search: function () {
      if (!this.modalShown) return
      this.errors = {}
      if (Object.keys(this.errors).length !== 0) {
        return false
      }
      this.callbackParams = {
        productCnt: this.productCnt,
        categoryList: this.selCategoryList,
        paramForm: this.paramForm,
        makerIdList: this.makerIdList
      }
      this.onOk(this.callbackParams)
      this.modalShown = false
    },
    cancel: function () {
      this.onCancel(this.callbackParams)
      this.modalShown = false
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    isOnReset: function () {
    },
    isOnSearch: function () {
    },
    onBlurStorageItemMinW: function () {
      if (!this.paramForm.minWidth || this.paramForm.minWidth < 0) {
        this.paramForm.minWidth = undefined
      }
      this.searchProductCnt()
    },
    onBlurStorageItemMinH: function () {
      if (!this.paramForm.minHeight || this.paramForm.minHeight < 0) {
        this.paramForm.minHeight = undefined
      }
      this.searchProductCnt()
    },
    onBlurStorageItemMinD: function () {
      if (!this.paramForm.minDepth || this.paramForm.minDepth < 0) {
        this.paramForm.minDepth = undefined
      }
      this.searchProductCnt()
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      str = FormUtil.deleteTopZero(str)
      return str
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    selectedAll: function (event) {
      event.target.select()
    },
    selectCategory: function (category) {
      // カテゴリ変更処理
      if (this.selCategoryList.find(c => c.id === category.id)) {
        this.selCategoryList = this.selCategoryList.filter(c => c.id !== category.id)
      } else {
        this.selCategoryList.push(category)
      }
      this.searchProductCnt()
      this.$forceUpdate()
    },
    selectMaker: function (makerId) {
      // カテゴリ変更処理
      if (this.makerIdList.find(c => c === makerId)) {
        this.makerIdList = this.makerIdList.filter(c => c !== makerId)
      } else {
        this.makerIdList.push(makerId)
      }
      this.searchProductCnt()
      // this.errors = {}
      this.$forceUpdate()
    },
    isSelCategory: function (id) {
      return this.selCategoryList.find(c => c.id === id)
    },
    categoryImgBlack: function (imgName) {
      let index = String(imgName).indexOf('.')
      let file = String(imgName).substring(0, index)
      let exp = String(imgName).substring(index, imgName.length)
      return this.getImage('category/' + file + '_black' + exp)
    },
    categoryImgWhite: function (imgName) {
      if (!imgName) return undefined
      let index = String(imgName).indexOf('.')
      let file = String(imgName).substring(0, index)
      let exp = String(imgName).substring(index, imgName.length)
      return this.getImage('category/' + file + '_white' + exp)
    },
    categoryName: function (name) {
      if (!name) return ''
      console.log('param:' + name)
      const s = name.replace('（', '\n（')
      return s
    },
    searchProductCnt: function () {
      let payload = {
        categoryList: this.selCategoryList.map(c => c.id),
        minWidth: this.paramForm.minWidth,
        maxWidth: this.paramForm.maxWidth,
        minHeight: this.paramForm.minHeight,
        maxHeight: this.paramForm.maxHeight,
        minDepth: this.paramForm.minDepth,
        maxDepth: this.paramForm.maxDepth,
        makerIdList: this.makerIdList
      }
      if (DC_PRPIC_ON === 1) {
        axios.post(DC_URL.TOP + '/prpic-cnt', payload)
          .then(response => {
            if (response.data.errorMessage) {
              this.handleErrorMessage(response)
            } else {
              this.productCnt = response.data.data
            }
          }).catch(error => {
            Api.handleError(error)
            this.modalShown = false
          }).finally(() => {
          })
      } else {
        axios.post(DC_URL.TOP + '/product-cnt', payload)
          .then(response => {
            if (response.data.errorMessage) {
              this.handleErrorMessage(response)
            } else {
              this.productCnt = response.data.data
            }
          }).catch(error => {
            Api.handleError(error)
            this.modalShown = false
          }).finally(() => {
          })
      }
    }
  }, // end method
  mounted: function () {
  },
  created: function () {
    let params = App.getLocalStorage(DC_STORAGE_KEY.PRODUCT_SEARCH)
    if (params && Object.keys(params).length > 0) {
      this.paramForm = Object.assign({}, params.paramForm)
      this.selCategoryList = Object.assign([], params.categoryList)
      this.makerIdList = Object.assign([], params.makerIdList)
      this.makerIdList.forEach(e => {
        if (e === 27) this.makerFm = true
        if (e === 1001) this.makerMiura = true
        if (e === 10000) this.makerAxis = true
        if (e === 10001) this.makerTecma = true
        if (e === 300) this.makerDomans = true
      })
    }
  }
}
</script>
<style src="../../../../css/dc-order.scss" lang="scss" scoped></style>
<style src="../../../../css/print.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/top/input/search/DcProductSearchModal.vue